/** Shared text fragments reused across Celeste host tool descriptions. */
export namespace CelesteHostToolsConstants {
  export const REPORT_TYPE_AMBIGUITY_DISCLAIMER =
    'IMPORTANT: There are two distinct report features in this app with similar names: a PDF report ' +
    '(/reports, static report layouts exported as PDF) and a Report Builder report ' +
    "(/reporting/list, the interactive report-building tool). If the user's request does not make it clear " +
    'which one they want, ask them to clarify ("Would you like a PDF report or a Report Builder report?") ' +
    'before proceeding.';
}
